import React from 'react';
import { AuthProvider } from 'oidc-react';
import AuthGate from './providers/AuthGate';
import { MockAuthProvider } from './providers/MockAuthProvider';
import AppRouter from './router';
import { TenantSelectionProvider } from './providers/TenantSelectionProvider';
import { TenantGroupAccessProvider } from './providers/TenantGroupAccessProvider';
import { ToastProvider } from './providers/ToastProvider/ToastContext';
import { SignalRProvider } from './providers/SignalRProvider/SignalRProvider';
import { NotificationProvider } from './providers/NotificationProvider/NotificationContext';
import { RemediationJobProvider } from './providers/RemediationJobProvider';

const oidcConfig = {
  onSignIn: async (user: any) => {
    const role = user.profile?.role;
    const userName = user.profile?.name;

    if (role) {
      localStorage.setItem('userRole', role);
    }
    if (userName) {
      localStorage.setItem('userName', userName);
    }

    // Redirect based on role
    if (role === 'globaladmin' || role === 'reseller') {
      window.location.href = '/customers';
    } else {
      window.location.href = '/';
    }
  },
  authority: process.env.REACT_APP_AUTHORITY,
  clientId: process.env.REACT_APP_CLIENT_ID,
  redirectUri: process.env.REACT_APP_REDIRECT_URI,
  responseType: 'code',
  scope: 'openid profile dashboard.full_access offline_access',
  postLogoutRedirectUri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI,
  // Renewal is activity-gated by IdleSessionManager (tokens only refresh while the user is active).
  automaticSilentRenew: false,
  // monitorSession: true,
};

function App() {
  return (
    <AuthProvider {...oidcConfig}>
      <AuthGate>
        <TenantSelectionProvider>
          <ToastProvider>
            <NotificationProvider>
              <SignalRProvider>
                <RemediationJobProvider>
                  <AppRouter />
                </RemediationJobProvider>
              </SignalRProvider>
            </NotificationProvider>
          </ToastProvider>
        </TenantSelectionProvider>
      </AuthGate>
    </AuthProvider>
  );
}

export default App;
